import React from 'react';
import PropTypes from 'prop-types';

import { useHasPermission } from '../../hooks/useHasPermission';
import FsTooltip from '../FsWrappers/FsTooltip/FsTooltip';

import { getPermissionDeniedTooltipText } from './PermissionUtils';
import { useRestrictedPermissions } from './RestrictedPermissions';
import { useWriteFreezeReason } from './WriteFreeze';

const PermissionDeniedTooltip = ({ children, action, verb }) => {
  const { userHasContextPermissions, permissionDeniedTooltipText } = useRestrictedPermissions();
  const userHasExplicitPermissions = useHasPermission({ action, verb });
  const explicitWriteFreezeReason = useWriteFreezeReason(verb);
  const shouldUseExplicitPermissions = action && verb;
  // A user who may not do it anyway reads why not; one who may reads why not now.
  const explicitPermissionsTooltipText = shouldUseExplicitPermissions
    ? (userHasExplicitPermissions && explicitWriteFreezeReason) || getPermissionDeniedTooltipText({ action, verb })
    : null;

  const tooltipText = explicitPermissionsTooltipText || permissionDeniedTooltipText;
  const isPermissionDenied = shouldUseExplicitPermissions
    ? !userHasExplicitPermissions || Boolean(explicitWriteFreezeReason)
    : !userHasContextPermissions;

  if (!children) return null;

  if (!isPermissionDenied) return <>{children}</>;

  return <FsTooltip title={tooltipText}>{children}</FsTooltip>;
};

PermissionDeniedTooltip.propTypes = {
  action: PropTypes.string,
  verb: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default PermissionDeniedTooltip;
